import React from 'react';
import PropTypes from 'prop-types';
import { FDBackButton } from '@facet-wealth/design';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import { useNavigateByRelationshipOnClick } from 'Views/Page/Hooks/useNavigateByRelationshipOnClick';

export const WizardBackButtonRel = ({
  resource, overrideOnClick, forceFocusMode, size,
}) => {
  const { onClick, loading } = useNavigateByRelationshipOnClick(resource.relationship(fr.relationships.previousLink.name), {
    forceFocusMode,
    overrideOnClick,
  });

  return resource.withRelationship(
    fr.relationships.previousLink.name,
    (rel) => (<FDBackButton
      {...dataAttrs('back-btn', resource)}
      label="Back"
      disabled={rel.meta('disabled')}
      loading={loading}
      onClick={onClick}
      size={size}
    />),
    () => null,
  );
};

WizardBackButtonRel.propTypes = {
  resource: PropTypes.object.isRequired,
  forceFocusMode: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
};
